import { Component, Input, OnInit, Inject, Optional } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
@Component({
  selector: 'kt-success-das',
  templateUrl: './success-das.component.html',
  styleUrls: ['./success-das.component.css']
})
export class SuccessDasComponent implements OnInit {

  @Input() title: string;
  @Input() message: string;
  @Input() btnOkText:string = 'OK';
  @Input() btnCancelText: string = 'Cancel';
  constructor(private dialogRef: MatDialogRef<SuccessDasComponent>,@Optional() @Inject(MAT_DIALOG_DATA) public data: any,) { }

  ngOnInit() {
    this.title = this.data.title;
    this.message = this.data.message;
  }

  public decline() {
    this.dialogRef.close(false);
  }

  public accept() {
    this.dialogRef.close(true);
  }

  public dismiss(type) {
    this.dialogRef.close(type);
  }
}
